import { Component, Input } from '@angular/core';

export type MainVariant = 'default' | 'primary';

@Component({
  selector: 'main[ui]',
  standalone: true,
  imports: [],
  templateUrl: './main.html',
  styleUrl: './main.css',
  host: {
    '[attr.data-variant]': 'variant',
    '[attr.aria-label]': 'ariaLabel',
  },
})
export class MainComponent {
  @Input() variant: MainVariant = 'default';
  @Input() ariaLabel = 'Page content';
}
